import React from "react";

const Row = ({ left, right }) => {
  return (
    <div className="flex w-full">
      <div className="flex-1 flex gap-1">{left}</div>

      <div>{right}</div>
    </div>
  );
};

export default Row;
